import React from 'react';
import { SearchInput, Select, Button } from '@/components/ui';
import type { QaFilters, InspectionStatus, InspectionResult } from '../types/construction-qa.types';

interface Props {
  filters: QaFilters;
  onFilterChange: (filters: QaFilters) => void;
  onAdd: () => void;
}

export const QaToolbar: React.FC<Props> = ({ filters, onFilterChange, onAdd }) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6 items-center justify-between bg-white p-4 rounded-2xl border border-slate-100 shadow-sm">
      <div className="flex flex-1 gap-4 w-full md:w-auto">
        <SearchInput
          placeholder="Tìm mã phiếu, nội dung..."
          value={filters.search}
          onChange={(val) => onFilterChange({ ...filters, search: val })}
          className="max-w-xs"
        />
        <Select
          value={filters.status}
          onValueChange={(val) => onFilterChange({ ...filters, status: val as InspectionStatus | 'all' })}
          options={[
            { value: 'all', label: 'Tất cả trạng thái' },
            { value: 'draft', label: 'Bản thảo' },
            { value: 'submitted', label: 'Đã gửi' },
            { value: 'passed', label: 'Đã đạt' },
            { value: 'failed', label: 'Không đạt' },
          ]}
          className="w-48"
        />
        <Select
          value={filters.result}
          onValueChange={(val) => onFilterChange({ ...filters, result: val as InspectionResult | 'all' })}
          options={[
            { value: 'all', label: 'Tất cả kết quả' },
            { value: 'pass', label: 'Đạt' },
            { value: 'fail', label: 'Không đạt' },
            { value: 'pending', label: 'Chờ xử lý' },
          ]}
          className="w-48"
        />
      </div>
      
      <div className="flex gap-2 w-full md:w-auto">
        <Button variant="outline" icon="ri-download-line">Xuất PDF</Button>
        <Button variant="primary" icon="ri-add-line" onClick={onAdd}>Tạo phiếu kiểm tra</Button>
      </div>
    </div>
  );
};
